import { Box, TextField } from '@mui/material';
import { useController } from 'react-hook-form';
import { FormattedNumber } from './formatted-number';
interface NumberInputProps {
  name: string;
  label: string;
  prefix?: string;
  suffix?: string;
  rules?: Object;
  defaultValue?: string | number;
  fullWidth?: boolean;
  startAdornment?: JSX.Element;
  endAdornment?: JSX.Element;
}
export function NumberInput({
  name,
  rules,
  label,
  prefix,
  suffix,
  startAdornment,
  endAdornment,
  defaultValue,
  fullWidth = true,
}: NumberInputProps) {
  const {
    field: { onChange, ref, value },
    fieldState: { error },
  } = useController({
    name,
    defaultValue,
    rules,
  });

  return (
    <Box>
      <FormattedNumber
        id={name}
        displayType='input'
        customInput={TextField}
        onValueChange={v => {
          const value = v.floatValue || v.value;
          onChange(value);
        }}
        value={value}
        error={Boolean(error)}
        helperText={error?.message}
        inputRef={ref}
        inputProps={{
          'aria-label': name,
        }}
        fullWidth={fullWidth}
        label={label}
        prefix={prefix}
        suffix={suffix}
        InputProps={{
          startAdornment,
          endAdornment,
        }}
      />
    </Box>
  );
}
